// src/app/core/store/claim-analytics/claim-analytics.state.ts

import {
  ClaimOverviewRow,
  ClaimTimeSeriesRow,
  ClaimBreakdownRow,
  ClaimRankingsRow,
  ClaimComparisonRow,
  ClaimProductSummary,
  ClaimProductConfig,
  ClaimCauseLookupItem,
  HealthBenefitTypeLookupItem,
} from '@shared/models/claim-analytics.model';

export interface AsyncSlice<T> {
  data: T | null;
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export function emptySlice<T>(): AsyncSlice<T> {
  return { data: null, loading: false, loaded: false, error: null };
}

export interface ClaimAnalyticsState {
  // ── Product config ──
  products: ClaimProductSummary[];
  productsLoading: boolean;
  productsLoaded: boolean;
  selectedProductTypeId: number | null;
  configs: Record<number, ClaimProductConfig>;
  configLoading: boolean;

  // ── Lookups ──
  cascoCauses: ClaimCauseLookupItem[];
  cascoCausesLoaded: boolean;
  healthBenefitTypes: HealthBenefitTypeLookupItem[];
  healthBenefitTypesLoaded: boolean;

  // ── Analytics data ──
  overview:   AsyncSlice<ClaimOverviewRow[]>;
  timeSeries: AsyncSlice<ClaimTimeSeriesRow[]>;
  breakdown:  AsyncSlice<ClaimBreakdownRow[]>;
  rankings:   AsyncSlice<ClaimRankingsRow[]>;
  comparison: AsyncSlice<ClaimComparisonRow[]>;
}

export const initialClaimAnalyticsState: ClaimAnalyticsState = {
  products: [],
  productsLoading: false,
  productsLoaded: false,
  selectedProductTypeId: null,
  configs: {},
  configLoading: false,

  cascoCauses: [],
  cascoCausesLoaded: false,
  healthBenefitTypes: [],
  healthBenefitTypesLoaded: false,

  overview:   emptySlice(),
  timeSeries: emptySlice(),
  breakdown:  emptySlice(),
  rankings:   emptySlice(),
  comparison: emptySlice(),
};
